export const truncar = (num, digitos) => {
  const re = new RegExp("(\\d+\\.\\d{" + digitos + "})(\\d)");
  const _num = num.toString().match(re);
  return _num ? _num[1] : num;
};
